import React from "react";

import { Grow } from "@mui/material";

import { Badge, BadgeProps } from "./styled";

interface AppBadgeProps extends BadgeProps {
  children?: React.ReactNode;
  hideOnFalse?: boolean;
}

export const AppBadge = (props: AppBadgeProps) => {
  const { children, hideOnFalse, ...rest } = props;

  if (hideOnFalse) {
    return <Grow in={!!children}>{children ? <Badge {...rest}>{children}</Badge> : <div />}</Grow>;
  }

  return <Badge {...rest}>{children}</Badge>;
};
